'use es6';

import styled from 'styled-components';
import UIBetaButton from 'UIComponents/button/UIBetaButton/UIBetaButton';
const PositionedBetaButton = styled(UIBetaButton).withConfig({
  displayName: "PositionedBetaButton",
  componentId: "qlwc06-0"
})(["position:fixed;bottom:17px;left:calc(var(--global-nav-vertical-nav-width,0) + 17px);z-index:900;"]);
export default PositionedBetaButton;